<template>
  <div>
    <vs-tabs v-model="activeTab" class="tab-action-btn-fill-container profile-tabs">
      <vs-tab label="Perfil" icon-pack="feather" icon="icon-pocket" >
        <investor-profile-v3 :investor-id="InvestorId" />
      </vs-tab>

      <vs-tab label="Portafolio" icon-pack="feather" icon="icon-pocket" >
        <investor-portfolio-v4 :investor-id="InvestorId" />
        <!-- <investor-portfolio-v3 :investor-id="InvestorId" /> -->
      </vs-tab>

      <vs-tab label="Proyectos" icon-pack="feather" icon="icon-pocket" >
        <projects-page :investor-id="InvestorId" />
      </vs-tab>

      <vs-tab label="Movimientos" icon-pack="feather" icon="icon-pocket" >
        <movements-page :investor-id="InvestorId" />
      </vs-tab>

      <vs-tab label="Estados de cuenta" icon-pack="feather" icon="icon-pocket" >
        <statements-page :investor-id="InvestorId" />
      </vs-tab>

      <vs-tab label="Forma de riego" icon-pack="feather" icon="icon-pocket" >
        <investment-plans :investor-id="InvestorId" />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import InvestorProfileV3 from "@/views/admin/investor/profile/InvestorProfileV3";
// import InvestorPortfolioV3 from "@/views/admin/investor/InvestorPortfolioV3";
import InvestorPortfolioV4 from "@/views/admin/investor/InvestorPortfolioV4";
import ProjectsPage from "@/views/admin/investor/ProjectsPage";
import MovementsPage from "@/views/admin/investor/MovementsPage";
import StatementsPage from "@/views/admin/investor/StatementsPage";
import InvestmentPlans from "@/views/admin/investor/InvestmentPlans";
export default {
  name: "InvestorProfileRootPage",
  props: {
    tab: { type: String, default: 'main' }
  },
  data(){
    return {
      activeTab: 0,
      InvestorId: null,
    }
  },
  beforeMount() {
    this.InvestorId = this.$route.params.id;
    this.activeTab = this.getInitialTabIndexFromCode();
  },
  components: {
    // InvestorPortfolioV3,
    InvestorPortfolioV4,
    InvestorProfileV3,
    ProjectsPage,
    MovementsPage,
    StatementsPage,
    InvestmentPlans
  },
  methods: {
    getInitialTabIndexFromCode(){
      switch (this.tab) {
        case "main":
          return 0;
        case "portafolio":
          return 1;
        case "proyectos":
          return 2;
        case "movimientos":
          return 3;
        case "estado-cuenta":
          return 4;
        case "plan":
          return 5;
        default:
          return 0;
      }
    },
  }
}
</script>

<style >
.profile-tabs .vs-tabs--li button {
  font-family: 'Gilroybold',sans-serif !important;
  font-weight: normal !important;
}
</style>